const Links = () => {
    return (
        <div id="links">
            <h2>Helpful Links:</h2>
            <ul>
                <li className="link">
                    <a href="https://www.edwards-instruments.com/" target="_blank" rel="noreferrer">
                        Edwards Instruments | Custom Trombones and Trumpets
                    </a>
                </li>
                <li className="link">
                    <a href="https://www.hickeys.com/" target="_blank" rel="noreferrer">
                        Hickey's Music Center
                    </a>
                </li>
                <li className="link">
                    <a href="https://www.woodsysmusic.com/" target="_blank" rel="noreferrer">
                        Woodsy's Music
                    </a>
                </li>
                <li className="link">
                    <a href="https://www.pellegrinomusic.com/" target="_blank" rel="noreferrer">
                        Pellegrino Music & Lesson Center
                    </a>
                </li>
                <li className="link">
                    <a href="https://www.mountunion.edu/dept-of-performing-arts" target="_blank" rel="noreferrer">
                        University of Mount Union | Department of Performing Arts
                    </a>
                </li>
                <li className="link">
                    <a href="https://www.trombone.net/" target="_blank" rel="noreferrer">
                        International Trombone Association
                    </a>
                </li>
            </ul>
        </div>
    )
}

export default Links;